import { useApi } from '../../composables/useApi';

const { api } = useApi();

export const companyApi = {
    getAll(params = {}) {
        return api.get('/admin/company', { params });
    },

    getById(id) {
        return api.get(`/admin/company/${id}`);
    },

    create(formData) {
        return api.post('/admin/company', formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    update(id, formData) {
        return api.post(`/admin/company/${id}`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    delete(id) {
        return api.delete(`/admin/company/${id}`);
    },

    getFormData() {
        return api.get('/admin/company/form-data');
    },

    getUserCompanies() {
        return api.get('/admin/company/user-companies');
    },

    switchCompany(companyId) {
        return api.post('/admin/company/switch', { company_id: companyId });
    },
};
